export enum ProjectHeaderElements {
  IMAGE = "image",
  TITLE = "title",
  STATUS = "status",
  KPIS = "kpis",
  TEAMS = "teams",
  PROJECT_TEAM = "projectTeam",
  HISTORY = "history",
  EXPAND = "expand",
  CTQ = "ctq",
  RISKS_AND_ISSUES = "risksAndIssues"
}
